<template>
  <svg :width="size" :height="size" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      :fill="fillCurrentColor ? 'currentColor' : '#E41827'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 5C0 7.76125 2.23875 10 5 10C7.76125 10 10 7.76125 10 5C10 2.23875 7.76125 0 5 0C2.23875 0 0 2.23875 0 5ZM5.44497 2.9875C5.44497 2.62625 5.19622 2.33375 4.88997 2.33375C4.58372 2.33375 4.33372 2.62625 4.33372 2.9875V5.44375C4.33372 5.805 4.58372 6.0975 4.88997 6.0975C5.19622 6.0975 5.44497 5.805 5.44497 5.44375V2.9875ZM4.88874 6.5075C4.58249 6.5075 4.33249 6.7675 4.33249 7.0875C4.33249 7.4075 4.58249 7.6675 4.88874 7.6675C5.19499 7.6675 5.44374 7.4075 5.44374 7.0875C5.44499 6.7675 5.19499 6.5075 4.88874 6.5075Z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ExclamationIcon extends Vue {
  @Prop({ default: '10' }) readonly size!: string | number;
  @Prop(Boolean) readonly fillCurrentColor!: boolean;
}
</script>
